import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import "../assets/SignagePlayer.css";
import { Image } from "antd";

const SignagePlayer = ({ playlist = [], classNames }) => {
  const playerRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [videoUrl, setVideoUrl] = useState("");
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  const currentMedia = playlist && playlist[currentIndex];

  const nextMedia = () => {
    if (
      playlist.length === 1 &&
      (currentMedia.media.media_type === "youtube" ||
        currentMedia.media.media_type === "video")
    ) {
      playerRef.current.seekTo(0, "seconds");
    }
    setCurrentIndex((prev) => (prev + 1) % playlist.length);
  };

  useEffect(() => {
    if (currentMedia) {
      if (
        currentMedia.media.media_type === "video" ||
        currentMedia.media.media_type === "image" ||
        currentMedia.media.media_type === "ppt"
      ) {
        const file_data = currentMedia.media.file_data;
        setVideoUrl(file_data.file_path);
      } else if (
        currentMedia.media.media_type === "youtube" ||
        currentMedia.media.media_type === "url"
      ) {
        setVideoUrl(currentMedia.media.url_data);
      }
      if (
        currentMedia.media.media_type === "image" ||
        currentMedia.media.media_type === "ppt"
      ) {
        const timer = setTimeout(
          nextMedia,
          currentMedia.duration * 1000 || 5000
        );
        return () => clearTimeout(timer);
      }
      console.log(
        "Playing " +
          currentMedia.media.media_type +
          " - " +
          currentMedia.media.title
      );
    }
  }, [currentIndex, currentMedia]);

  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={`${classNames} signage-wrapper`}>
      {(currentMedia.media.media_type === "video" ||
        currentMedia.media.media_type === "url" ||
        currentMedia.media.media_type === "youtube") && (
        <ReactPlayer
          config={{
            youtube: {
              playerVars: {
                controls: 0,
                modestbranding: 1,
                rel: 0,
                showinfo: 0,
              },
            },
          }}
          ref={playerRef}
          url={videoUrl}
          playing
          muted={isMuted}
          loop={false}
          controls={false}
          width="100%"
          height="100%"
          onEnded={nextMedia}
          onReady={() => {
            const ytPlayer = playerRef.current?.getInternalPlayer();
            if (
              currentMedia.media.media_type === "youtube" &&
              !isMuted &&
              ytPlayer?.unMute
            ) {
              ytPlayer.unMute(); // Force unmute
            }
          }}
          onPlay={() => {
            const ytPlayer = playerRef.current?.getInternalPlayer();
            if (
              currentMedia.media.media_type === "youtube" &&
              ytPlayer?.isMuted &&
              typeof ytPlayer.isMuted === "function" &&
              ytPlayer.isMuted() === false
            ) {
              setIsMuted(false); // Save the unmuted state globally
            }
          }}
        />
      )}
      {currentMedia.media.media_type === "image" && (
        <div className="text-center bg-black">
          <Image src={videoUrl} height={"100vh"} preview={false} />
        </div>
      )}
      {currentMedia.media.media_type === "ppt" && (
        <div className="text-center bg-black">
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              videoUrl
            )}&start=true&loop=true&delayms=3000`}
            width="100%"
            height={`${screenHeight}px`}
            frameBorder="0"
            title={currentMedia.media.title}
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default SignagePlayer;
